import { initialOutputs } from 'utils/helpers';
import {
  GET_SCENARIOS_REQUEST,
  GET_SCENARIOS_SUCCESS,
  GET_SCENARIOS_FAILED,
  ADD_SCENARIO_REQUEST,
  ADD_SCENARIO_SUCCESS,
  ADD_SCENARIO_FAILED,
  GET_DATASOURCES_REQUEST,
  GET_DATASOURCES_SUCCESS,
  GET_DATASOURCES_FAILED,
  SET_INPUTS,
  SET_OUTPUTS,
  RESET_DATA
} from '@redux/types';

const INITIAL_STATE = {
  scenarios: [],
  outputs: initialOutputs,
  inputs: {},
  scenario: null,
  datasources: [],
  loading: false,
  error: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SCENARIOS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_SCENARIOS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        scenarios: action.scenarios
      };
    case GET_SCENARIOS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case ADD_SCENARIO_REQUEST:
      return {
        ...state,
        loading: true
      };
    case ADD_SCENARIO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        outputs: action.outputs
      };
    case ADD_SCENARIO_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case GET_DATASOURCES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_DATASOURCES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        datasources: action.datasources
      };
    case GET_DATASOURCES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case SET_INPUTS:
      return {
        ...state,
        loading: false,
        inputs: action.inputs
      };
    case SET_OUTPUTS:
      return {
        ...state,
        loading: false,
        outputs: action.outputs
      };
    case RESET_DATA:
      return INITIAL_STATE;
    default:
      return state;
  }
};
